export default "__VITE_ASSET__DqDEGa6s__"